"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMRDAppUrl = void 0;
const react_1 = require("react");
const utils_1 = require("../../utils");
const useMRDAppUrl = (appleStoreUrl, googlePlayUrl) => {
    const [url, setUrl] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        if (utils_1.isMobile.iOS() || (!utils_1.isMobile.any() && utils_1.isBrowser.Safari())) {
            setUrl(appleStoreUrl);
        }
        else {
            setUrl(googlePlayUrl);
        }
    });
    return url;
};
exports.useMRDAppUrl = useMRDAppUrl;
